export function urlJoin(...paths) {
    return paths
        .map(p => p.replace(/\/+$/, ''))
        .join('/');
}



// WEBPACK FOOTER //
// ./src/utils/url-utils.js